module.exports = __webpack_public_path__ + "static/2-5a02114a7a40eedda1a95fcc3363dbe5.jpg";